import { Icon } from './Icon.tsx';
import { dv } from '../i18n/dv.ts';

// Ecosystem jump to WapSign. SSO handoff is wired later with document features;
// for now this is a plain link (ambient SSO signs the user in on arrival).
export function AppSwitcher({ variant }: { variant: 'header' | 'sidebar' }): JSX.Element {
  if (variant === 'header') {
    return (
      <a
        href="https://sign.wapplify.app"
        aria-label={dv.nav.wapsign}
        className="grid size-11 place-items-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/70"
      >
        <Icon name="edit_square" size={20} />
      </a>
    );
  }
  return (
    <a
      href="https://sign.wapplify.app"
      className="flex w-full items-center gap-4 rounded-full px-4 py-2.5 text-[0.95rem] text-muted-foreground hover:bg-muted/70 hover:text-foreground"
    >
      <Icon name="edit_square" size={22} />
      <span>{dv.nav.wapsign}</span>
    </a>
  );
}
